// extracted by mini-css-extract-plugin
var _1 = "BoardActions_action__4ShVr";
var _2 = "BoardActions_actionFlex__5+0MQ";
var _3 = "BoardActions_actionRightFirst__M9cxM";
var _4 = "BoardActions_actionRightLast__sLNN5";
var _5 = "BoardActions_active__y6+4Q";
var _6 = "BoardActions_cardsCount__xFf8S";
var _7 = "BoardActions_cardsCountAction__TXiG1";
var _8 = "BoardActions_githubAction__MbwzQ";
var _9 = "BoardActions_githubGreen__HjN62";
var _a = "BoardActions_githubGrey__8XjmR";
var _b = "BoardActions_subscriptionButton__DbNiv";
var _c = "BoardActions_switchViewButton__kCknZ";
var _d = "BoardActions_title__jMP-z";
var _e = "BoardActions_wrapper__rxxRn";
export { _1 as "action", _2 as "actionFlex", _3 as "actionRightFirst", _4 as "actionRightLast", _5 as "active", _6 as "cardsCount", _7 as "cardsCountAction", _8 as "githubAction", _9 as "githubGreen", _a as "githubGrey", _b as "subscriptionButton", _c as "switchViewButton", _d as "title", _e as "wrapper" }
